import React from 'react';
import SpreadsheetManager from '@paperstac/ui/lib/spreadsheet/SpreadsheetManager';
import Spreadsheet from '@paperstac/ui/lib/spreadsheet/Spreadsheet';
import CurrencyCell from '@paperstac/ui/lib/spreadsheet/CurrencyCell';
import TextCell from '@paperstac/ui/lib/spreadsheet/TextCell';
import { getOrdinal } from '@paperstac/helpers/lib/number';
import Checkbox from '@paperstac/ui/lib/form/Checkbox';
import Box from '@paperstac/ui/lib/Box';

const SelectServicerLoansSpreadsheet = React.memo(({ selectedLoanIds, servicerLoans, toggleLoanId }) => {
  const cellRenderer = ({ style, value, row: { id }, column: { prop } }) => {
    const map = {
      checkbox: () => (
        <TextCell style={style}>
          <Box sx={{ pl: '5px' }}>
            <Checkbox onChange={() => toggleLoanId(id)} checked={selectedLoanIds.includes(id)} />
          </Box>
        </TextCell>
      ),
      lienPosition: () => <TextCell style={style}>{getOrdinal(value)}</TextCell>,
      performance: () => <TextCell style={style}>{value === 'Non-Performing' ? 'Non-Perf' : value}</TextCell>,
      upb: () => <CurrencyCell style={style} cents={value} />,
    };
    return map[prop] ? map[prop]() : <TextCell style={style}>{value}</TextCell>;
  };

  return (
    <SpreadsheetManager
      headerCells={[
        { prop: 'checkbox', label: '', width: 40 },
        { prop: 'borrowerName', label: 'Borrower', width: 200 },
        { prop: 'upb', label: 'UPB', width: 120 },
        { prop: 'performance', label: 'Performing', width: 120 },
        { prop: 'lienPosition', label: 'Lien', width: 60 },
        { prop: 'streetAddress1', label: 'Street Address', width: 200 },
        { prop: 'city', label: 'City', width: 120 },
        { prop: 'state', label: 'State', width: 60 },
        { prop: 'zip', label: 'Zip', width: 80 },
      ]}
      rows={servicerLoans.map((sl) => ({ ...sl, ...sl.loan }))}
    >
      <Spreadsheet cellRenderer={cellRenderer} />
    </SpreadsheetManager>
  );
});

SelectServicerLoansSpreadsheet.defaultProps = {};

SelectServicerLoansSpreadsheet.displayName = 'SelectServicerLoansSpreadsheet';

export default SelectServicerLoansSpreadsheet;
